<template>
  <div class="max-w-7xl mx-auto px-6 sm:px-12 md:px-16 lg:px-24 xl:px-32 py-16">
    <h1 class="text-center text-[48px] leading-[56px] text-[#0B1441] font-normal mb-2">
      Nos Services
    </h1>
    <div class="w-px h-6 mx-auto bg-[#6B4B3A] mb-20"></div>

    <div class="flex flex-col md:flex-row md:items-start md:space-x-20">
      <div class="md:w-1/2">
        <p class="text-[14px] leading-[18px] font-semibold tracking-widest text-[#B33A2B] mb-4 uppercase">
          Bien-être & Beauté
        </p>
        <h2 class="text-[#0B1441] text-[48px] leading-[56px] font-normal max-w-md">
          Des soins pensés pour sublimer votre beauté naturelle
        </h2>
      </div>
      <div class="md:w-1/2 mt-10 md:mt-0 max-w-lg text-[#4b3b2b]">
      <p class="mb-8">
        Chez <strong>Naturel & Joli</strong>, chaque soin est une invitation à la détente et à la redécouverte de soi. Notre équipe experte vous accueille dans un espace chaleureux et apaisant pour révéler l’éclat de votre beauté naturelle.
      </p>
      <p>
        De l’épilation au soin du visage, en passant par les massages relaxants et les prestations esthétiques, nous mettons notre savoir-faire au service de votre bien-être. Offrez-vous un moment rien que pour vous.
      </p>
    </div>
    </div>
  </div>

  <div class="max-w-7xl mx-auto px-6 sm:px-10 md:px-16 py-16">
    <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
      <div
        v-for="category in categories"
        :key="category.name"
        class="bg-white/60 backdrop-blur-md rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-white/30 hover:-translate-y-1 cursor-pointer text-center flex flex-col items-center"
        @click="goToCategory(category.route)"
      >
        <div :class="`w-24 h-24 ${category.bg} flex items-center justify-center rounded-full mb-4`">
          <img :src="category.image" :alt="category.name" class="w-24 h-24 rounded-full object-cover" />
        </div>
        <span class="text-[#1A2243] text-lg font-semibold">{{ category.name }}</span>
      </div>
    </div>
  </div>
  <LoopText />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()

const categories = ref([])

const goToCategory = (route) => {
  router.push(`/services/${route}`)
}

// Fonction pour formater le nom en slug pour la route
const toSlug = (text) => {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // retire les accents
    .replace(/\s+/g, '-') // remplace les espaces par des tirets
    .replace(/[^\w-]+/g, '') // supprime les caractères non alphanumériques sauf le tiret
    .replace(/--+/g, '-') // remplace les tirets consécutifs par un seul
    .replace(/^-+/, '') // supprime les tirets en début
    .replace(/-+$/, ''); // supprime les tirets en fin
};


const fetchCategories = async () => {
  try {
    const response = await axios.get('https://bookmysalon-967a856b16b6.herokuapp.com/api/categorie');
    categories.value = response.data
      .filter(categorie => categorie.statut === 'Active') // Filtrer les catégories actives
      .map(categorie => ({
        name: categorie.nom,
        route: toSlug(categorie.nom),
        image: categorie.image || 'https://via.placeholder.com/150',
        bg: 'bg-gray-100', // tu peux ajuster dynamiquement si tu veux
      }));
  } catch (error) {
    console.error('Erreur lors de la récupération des catégories:', error);
  }
};


onMounted(fetchCategories)
</script>


